'use client'

import { ChevronDown, Wallet } from 'lucide-react'
import { TokenLogo } from './TokenLogo'
import type { Token } from '@/types/token'


interface SwapInputProps {
  label: string
  amount: string
  onAmountChange: (amount: string) => void
  token: Token | null
  onTokenSelect: () => void
  usdValue: string
  balance: string
  readOnly?: boolean
}

export function SwapInput({
  label,
  amount,
  onAmountChange,
  token,
  onTokenSelect,
  usdValue,
  balance,
  readOnly = false
}: SwapInputProps) {
  return (
    <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700/30">
      <div className="flex items-center justify-between mb-3">
        <span className="text-slate-400 text-sm">{label}</span>
      </div>

      <div className="flex items-center justify-between gap-4">
        <div className="flex-1">
          <input
            type="text"
            value={amount}
            onChange={(e) => onAmountChange(e.target.value)}
            readOnly={readOnly}
            className="w-full bg-transparent text-white text-3xl font-medium placeholder:text-slate-500 focus:outline-none"
            placeholder="0"
          />
          <div className="text-slate-400 text-sm mt-4 text-left">$ {usdValue}</div>
        </div>

        <div className="flex flex-col items-end gap-2">
          <button
            className="flex items-center gap-2 bg-slate-800 hover:bg-slate-700 rounded-full px-2 py-2 transition-colors cursor-pointer"
            onClick={onTokenSelect}
          >
            {token ? (
              <>
                <TokenLogo
                  tokenAddress={token.address}
                  tokenSymbol={token.symbol}
                  alt={token.symbol}
                  width={28}
                  height={28}
                />
                <span className="text-white font-medium">{token.symbol}</span>
              </>
            ) : (
                <>
                  <div className="w-7 h-7 rounded-full bg-slate-700/50 animate-pulse"></div>
                  <div className="w-12 h-5 bg-slate-700/50 rounded animate-pulse"></div>
                </>
            )}
            <ChevronDown className="w-4 h-4 text-slate-400" />
          </button>

          <div className="flex items-center gap-1 text-slate-400 text-sm mt-2">
            <Wallet className="w-3 h-3" />
            <span>{balance}</span>
          </div>
        </div>
      </div>
    </div>
  )
}